import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Tag } from "../../utils/GTMPageTag";
import "./Thanks.scss";

const Thanks = () => {
  Tag("Thanks")
  const { t } = useTranslation(["common","thanks"]);
  return(
    <div className="ThanksBox">
      <h1>{t('thanks:heading')}</h1>
      <p>{t('thanks:description')}</p>
      <Link to="/">{t('thanks:link')}</Link>
    </div>
  )
};
export default Thanks;